module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/slider/image13-5da5b0dd408bdb580dc5d2f10e395901.jpg";